import React from "react";
import PropTypes from "prop-types";
import classes from "./area.module.scss";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

function AreaChartComponent(props) {
  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>Діаграма вмісту хімічних речовин</h2>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={props.currentChemical}
          margin={{ top: 50, right: 50, left: 25, bottom: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            label={{
              value: "ЧАС",
              angle: 0,
              position: "bottom",
              offset: 0,
            }}
          />
          <YAxis
            label={{
              value: props.title.toUpperCase(),
              angle: -90,
              position: "left",
              offset: 0,
              offsetX: 10,
            }}
          />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="pv"
            stroke="blue"
            fill="rgba(82, 182, 236,0.4)"
          />
          <ReferenceLine
            y={props.maxConsistency}
            label={{ value: "max", position: "right" }}
            stroke="red"
            strokeDasharray="9 3"
            isFront={true}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

AreaChartComponent.propTypes = {
  currentChemical: PropTypes.array,
  maxConsistency: PropTypes.number,
  title: PropTypes.string,
};

export default AreaChartComponent;
